import { CatIconCva } from '@blocks-react/components/Icons/Cva';
import { CustomerValueAgreementsButtonProps } from '../types';
import { MyEquipmentButton } from '../../my-equipment-button';
import styles from '../CustomerValueAgreements.module.scss';

export const CustomerValueAgreementsButton = ({
  children,
  onClick
}: CustomerValueAgreementsButtonProps) => {
  return (
    <MyEquipmentButton
      variant="ghost"
      className={styles['cva-button']}
      onClick={onClick}
    >
      {children}
      <CatIconCva slot="before" className={styles['icon-color']} />
    </MyEquipmentButton>
  );
};
